"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var globalTypes_1 = require("../../../gen-src/queries/globalTypes");
var GraphQLErrorFunctions_1 = require("../../error/functions/GraphQLErrorFunctions");
var DatasourceTypeCell_1 = require("../datagrid/cellFormatters/DatasourceTypeCell");
var IconCellFormatter_1 = require("../datagrid/cellFormatters/IconCellFormatter");
var LinkCellFormatter_1 = require("../datagrid/cellFormatters/LinkCellFormatter");
var NumberCellFormatter_1 = require("../datagrid/cellFormatters/NumberCellFormatter");
var ObfuscatedCellFormatter_1 = require("../datagrid/cellFormatters/ObfuscatedCellFormatter");
var TextCellFormatter_1 = require("../datagrid/cellFormatters/TextCellFormatter");
var UserNameCell_1 = require("../datagrid/cellFormatters/UserNameCell");
var SortableHeaderFormatter_1 = require("../datagrid/headerFormatters/SortableHeaderFormatter");
var TypedDataGridInterfaces_1 = require("../datagrid/TypedDataGridInterfaces");
var ExplorerStyledDisplayGrid_1 = require("./ExplorerStyledDisplayGrid");
var shouldBeObfuscated = function (_a) {
    var name = _a.name;
    return name === null;
};
function getRowDataForDatasource(datasource) {
    return {
        id: datasource.id,
        name: datasource.name,
        description: datasource.description || '',
        owner: datasource.owner,
        workbookCount: datasource.downstreamWorkbooksConnection ? datasource.downstreamWorkbooksConnection.totalCount : null,
        vizportalUrlId: datasource.vizportalUrlId,
        extractLastUpdateTime: datasource.extractLastUpdateTime || null,
        projectName: datasource.projectName,
        projectVizportalUrlId: datasource.projectVizportalUrlId,
        hasExtracts: !!datasource.hasExtracts,
        isCertified: datasource.isCertified,
        certifier: datasource.certifier,
        certificationNote: datasource.certificationNote || ''
    };
}
exports.getRowDataForDatasource = getRowDataForDatasource;
var columns = [
    function (sortParams) { return ({
        name: 'type',
        dataKey: globalTypes_1.PublishedDatasourceOrderField.IS_CERTIFIED,
        cellFormatter: IconCellFormatter_1.createIconCellFormatter(function (_a) {
            var isCertified = _a.isCertified, hasExtracts = _a.hasExtracts, certifier = _a.certifier, certificationNote = _a.certificationNote;
            return (React.createElement(DatasourceTypeCell_1.DatasourceTypeCell, { isCertified: isCertified, hasExtracts: hasExtracts, certifier: certifier, certificationNote: certificationNote }));
        }, function (_a) {
            var hasExtracts = _a.hasExtracts;
            return hasExtracts ? Localize_1.Messages.DataDetailsDatasourceExtract() : Localize_1.Messages.DataDetailsDatasourceLive();
        }),
        headerText: Localize_1.Messages.GridHeaderType(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'name',
        dataKey: globalTypes_1.PublishedDatasourceOrderField.NAME,
        headerText: Localize_1.Messages.GridHeaderName(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedLinkCellFormatter(shouldBeObfuscated, function (_a) {
            var name = _a.name;
            return name;
        }, function (urls, _a) {
            var vizportalUrlId = _a.vizportalUrlId;
            return urls.datasourceLineagePath(vizportalUrlId);
        }),
        resizable: true,
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'downstreamWorkbooks',
        dataKey: globalTypes_1.PublishedDatasourceOrderField.DOWNSTREAM_WORKBOOKS_COUNT,
        headerText: Localize_1.Messages.GridHeaderConnectionCountWorkbooks(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams, 'right'),
        cellFormatter: NumberCellFormatter_1.createNumberCellFormatter(function (_a) {
            var workbookCount = _a.workbookCount;
            return workbookCount;
        }),
        resizable: true,
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'extractLastUpdateTime',
        dataKey: TypedDataGridInterfaces_1.UnsortableColumnKey,
        cellFormatter: TextCellFormatter_1.createTextCellFormatter(function (_a) {
            var hasExtracts = _a.hasExtracts, extractLastUpdateTime = _a.extractLastUpdateTime;
            return !hasExtracts
                ? Localize_1.Messages.LiveConnection()
                : extractLastUpdateTime !== null
                    ? Localize_1.Formatters.formatMediumDateTimeWithoutSeconds(new Date(extractLastUpdateTime))
                    : '';
        }),
        headerText: Localize_1.Messages.GridHeaderLastExtract(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        sortable: false,
    }); },
    function (sortParams) { return ({
        name: 'project',
        dataKey: globalTypes_1.PublishedDatasourceOrderField.PROJECT_NAME,
        headerText: Localize_1.Messages.GridHeaderProject(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: LinkCellFormatter_1.createLinkCellFormatter(function (_a) {
            var projectName = _a.projectName;
            return projectName || '';
        }, function (urls, _a) {
            var projectVizportalUrlId = _a.projectVizportalUrlId;
            return urls.projectPath(projectVizportalUrlId);
        }),
        resizable: true,
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'owner',
        dataKey: TypedDataGridInterfaces_1.UnsortableColumnKey,
        headerText: Localize_1.Messages.GridHeaderOwner(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: UserNameCell_1.createUserNameLinkCellFormatter(function (_a) {
            var owner = _a.owner;
            return owner;
        }),
        resizable: true,
        sortable: false,
    }); }
];
function DatasourcesDisplayGrid(props) {
    var cols = columns.map(function (columnFactory) { return columnFactory(props); });
    return (React.createElement(ExplorerStyledDisplayGrid_1.ExplorerStyledDisplayGrid, { columns: cols, rowStore: props.rowStore, emptyGridMessage: props.emptyGridMessage, rowCount: props.rowCount, renderErrors: GraphQLErrorFunctions_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.DatasourcesDisplayGrid = DatasourcesDisplayGrid;
//# sourceMappingURL=DatasourcesDisplayGrid.js.map